import React from 'react';
import { Col, Row } from 'antd';
// import { WarningOutlined } from '@ant-design/icons';

const UAFFormInfo = () => (
  <Row>
    <Col>
      <p className="previousStepForm__title--bold">Paso 2: Formulario UAF</p>
      <p className="previousStepForm__subtitle">
        A continuación deberás completar la Declaración Jurada para la identificación de
        beneficiarios finales de personas y/o estructuras jurídicas.
      </p>
      {/* <p className="previousStepForm__subtitle--secondary">
        <WarningOutlined style={{ color: '#B22938' }} /> <strong>Nota:</strong> Puedes guardar tu
        proceso y completar este paso más adelante mientras buscas los antecedentes requeridos. Sin
        embargo, para finalizar el proceso y concretar la firma del contrato, deberás tener cargada
        toda la documentación.
      </p> */}
    </Col>
  </Row>
);

export default UAFFormInfo;
